import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { ResellersService } from "src/app/core/api/services";
import { AppResellerSelectSearch } from "src/app/core/types/app-phonebook-select-search.type copy";
import { BaseSelectSearch } from "./base/base-select-search.component";
import { BaseSelectSearchModule } from "./base/base-select.search.module";

@Component({
    selector: "resellers-select-search",
    templateUrl: "./base/base-select-search-template.html",
    imports: [BaseSelectSearchModule]
})
export class ResellersSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input("type") type: AppResellerSelectSearch = "resellers";
  @Output("defaultValue") output_defaultValue = new EventEmitter<number>();

  constructor(protected currentService: ResellersService) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = "common.organization";
    this.optionValue = "id";
    this.optionTitle = "userName";
  }
  override getItems(): void {
    this.getItemsApi();
  }

  getItemsApi() {
    switch (this.type) {
      case "resellers": {
        this.currentService
          .resellersGetResellersWithPagination({ body: {} })
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      }
      case "currentOrganizationResellers": {
        this.optionValue = "userId";
        this.optionTitle = "userName";
        this.currentService
          .resellersGetCurrentOrganizationResellers()
          .pipe(this.basePipeOperators())
          .subscribe(this.baseObserver);
        break;
      }
    }
  }
}
